import { GameEvents } from '../../GameEvents';
import { WorldTrigger } from './WorldTrigger';

export class WorldExit extends WorldTrigger {
  constructor(scene, layer, config) {
    super(scene, layer, { ...config, trigger: GameEvents.EXIT_STAGE, destroyOnTrigger: true });
  }
}
